module.exports = __webpack_public_path__ + "static/pic_videoShadow-0231f786711e92f02dbafffd3a69b439.png";